export const AVAILABLE_YEARS = [
  2024,2023,2022,2021,2020,2019
]

export const COMTRADE_DATA_YEAR = [
  2023, 2024
]

export const ASEAN_MEMBER = ['IDN','MYS','PHL','SGP','THA','VNM','BRN','KHM','LAO','MMR']

export const HS_DIGITS = [
  {
    value: 1,
    label: 'HS Sections'
  },
  {
    value: 2,
    label: '2 Digit'
  },
  {
    value: 4,
    label: '4 Digit'
  },
  {
    value: 6,
    label: '6 Digit'
  }
]

export const HIGHCHART_COLORS = [
  '#FD9D24', '#00689D', '#56C02B', '#C5192D', '#E8F7A8', '#FF3A21', '#26BDE2', '#FCC30B', '#E06C8F', '#4C9F38', '#90C3D4', '#E8E790', '#F7838B', '#A290D4', '#E890C6', '#83F798', '#83C3F7', '#E89A33'
]

export const FTA_IMPACT_SETTING_GUIDE = {
  TRADE_DATA_YEAR:{
    header:'Import Data Year',
    body:'Choose the reference year for the trade data used in the partial equilibrium simulation.'
  },
  REPORTER:{
    header:'Reporter Country',
    body:'Exporter (facing tariffs).'
  },
  PARTNER:{
    header:'Partner Country',
    body:'Importer liberalizing tariffs for the selected reporter country'
  },
  SUPPLY_ELASTICITY:{
    header:'Supply Elasticity',
    body:`By default, TINA employs a supply elasticity value of 999, indicative of perfectly elastic supply, which is appropriate for modeling a small country's impact on global markets, wherein such impact is negligible. However, in scenarios where imports of a specific product from a larger entity, such as the European Union, are substantial and exert a significant influence on global price levels, it is advisable to reduce the supply elasticity parameter.`
  },
  SUBSTITUTION_ELASTICITY:{
    header:'Substitution Elasticity',
    body:`The default value for substitution elasticity is set at 1.5. Higher values indicate a greater degree of interchangeability between products from different countries. For instance, commodities such as metals, which are essentially uniform regardless of their country of origin, necessitate a higher substitution elasticity. Conversely, as products become more sophisticated, their substitutability decreases, resulting in greater rigidity.`
  },
  IMPORT_DEMAND_ELASTICITY_2020:{
    header:'Import Demand Elasticity',
    body:`<a href="https://www.unescap.org/resources/new-global-estimates-import-demand-elasticities-technical-note" target="_blank"> Utoktham, C., Kravchenko, A., & Duval, Y. (2020). New global estimates of import demand elasticities:a technical note.</a>`
  },
  IMPORT_DEMAND_ELASTICITY_2008:{
    header:'Import Demand Elasticity',
    body:`<a href="https://www.researchgate.net/publication/23547012_Import_Demand_Elasticities_and_Trade_Distortions" target="_blank"> Kee, H. L., Nicita, A., & Olarreaga, M. (2008). Import demand elasticities and trade distortions.  The Review of Economics and Statistics`
  },
  IMPORT_DEMAND_ELASTICITY:{
    header:'Import Demand Elasticity',
    body:`
      <p>
        Import demand elasticity measures the responsiveness of imports to changes in import prices (e.g. due to tariff changes). It reflects how buyers in partner country (importer country) adjust their import purchases when prices change due to tariff changes. These elasticates indicate that as import prices decrease, the quantity demanded increases, and vice versa. Its magnitude determines whether demand is elastic (highly responsive) or inelastic (less responsive), influencing the expected impact of trade policy changes, such as tariff reductions under a free trade agreement, on a country's import patterns. These elasticities have been econometrically estimated – select your preferred estimation method or see underlying technical papers for details:
      </p>
      <a href="https://www.unescap.org/resources/new-global-estimates-import-demand-elasticities-technical-note" target="_blank"> Utoktham, C., Kravchenko, A., & Duval, Y. (2020). New global estimates of import demand elasticities:a technical note.</a>
      <br/><br/>
      <a href="https://www.researchgate.net/publication/23547012_Import_Demand_Elasticities_and_Trade_Distortions" target="_blank"> Kee, H. L., Nicita, A., & Olarreaga, M. (2008). Import demand elasticities and trade distortions.  The Review of Economics and Statistics`
  },
}

export const IO_SETTING_GUIDE = {
  MIRROR_DATA_SWITCH:{
    header:'Mirror Trade Data',
    body:`
      <p>
        A country's reported export values can sometimes differ significantly from the corresponding mirror values (i.e., reported imports by trade partners). These discrepancies may arise for various reasons, including differences in valuation methods (e.g., CIF for imports vs. FOB for exports), variations in product classification by trade partners, time lags in reporting, and misinvoicing, which may be linked to illicit financial flows or trade-based money laundering. 
      </p>
      <p>
        To examine these trade data discrepancies, see <a target="_blank" href="INSERT_LINK">here</a>
      </p>
      <p>
        To learn more about trade misinvoicing and trade data discrepancies, see: <a target="_blank" href="https://repository.unescap.org/handle/20.500.12870/1176">Kravchenko, A. (2018). Where and how to dodge taxes and shift money abroad using trade misinvoicing: A beginner’s guide (Trade, Investment and Innovation Working Paper Series, Vol. 1, Issue April 2018). United Nations ESCAP.</a>
      </p>
    `
  }
}